import { Icon } from '@aqarmap/aqarmap-ui';

export default function ListingMediaIndicator({
  photos,
  videoURL,
  className = '',
}: {
  photos: number;
  videoURL: string | null;
  className?: string;
}) {
  const hasVideo = Boolean(videoURL);
  const totalAssets = photos + Number(hasVideo ? 1 : 0);

  if (!totalAssets) return null;

  return (
    <div className={`flex w-full  absolute bottom-x  ${className}`}>
      <div className="flex w-auto items-center gap-0.5x bg-gray__dark_2 rounded-[6px] px-x ">
        <Icon
          name="camera"
          size="16px"
          className="flex text-[16px] text-white"
        />
        <span className="text-white text-caption">{photos}</span>
        {hasVideo && (
          <>
            <span className="text-white text-caption-1">|</span>
            <Icon name="camera" size="16px" className="flex text-[16px]" />
            <span className="text-white text-caption">1</span>
          </>
        )}
      </div>
    </div>
  );
}
